<template>
  <div class="salesOrder">
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        title="附件"
        append-to-body
        class="attachment-edit"
        width="800px"
        top="0"
        @close="closePage">
      <el-form ref="form" v-loading="contentLoading" class="form" label-width="100px">
        <div>
          <upload-file
              ref="upload"
              :disabled="disable"
              :auth-index="authIndex"
              style="margin-left: 5px; float: left"
              @upload-success="uploadSuccess"/>
        </div>
        <el-table ref="payData1" :data="attachments" border>
          <el-table-column type="index" align="center" label="#" width="55"/>
          <el-table-column prop="fileName" align="left" label="附件描述" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-input v-model="scope.row.fileName" class="tabInput" style="width: 400px; margin: 0 auto; text-align: center"/>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120px" align="center" class-name="vm-table_operate">
            <template slot-scope="scope">
              <down-load-file :file-key="scope.row.filePath"/>
              <el-button :disabled="disable" type="danger" @click="oneDelete2(scope.row, scope.$index)"> 删除 </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import UploadFile from "@/components/UploadFile.vue";
  import DownLoadFile from "@/components/DownLoadFile.vue";
  export default {
    name: "AttachmentList",
    components: {
      UploadFile,
      DownLoadFile,
    },
    data() {
      return {
        contentLoading: false,
        dialogVisible: false,
        submitLoading: false,
        authIndex: this.$route.meta.authIndex,
        disable: false,
        pkid: "",
        files: [],
        fileList: [],
        attachments: [],
        actionUrl: window.config.basicServerUrl + "file/upload",
      };
    },
    mounted() {
      console.log(this.$route);
    },

    methods: {
      open(row) {
        this.dialogVisible = true;
        this.pkid = row.pkId;
        if (row.status === 30) {
          this.disable = true;
        }
        this.getData();
      },

      // 根据id查询附件详细信息
      getData() {
        this.contentLoading = true;
        this.$http.post("basic", `taskMembers/getTaskAttachments/${this.pkid}`).then((res) => {
          if (res.success) {
            this.attachments = res.data;
          }
          this.contentLoading = false;
        });
      },

      //文件上传成功后
      uploadSuccess(fileList) {
        console.log(fileList);
        if (fileList.length) {
          const params = {
            fileName: fileList[0].name,
            filePath: fileList[0].key,
          };
          this.attachments.push(params);
        }
        console.log(this.attachments);
      },

      //页面关闭时清空附件列表
      closePage() {
        this.attachments = [];
      },

      // 删除附件
      oneDelete2(row, index) {
        console.log(row);
        this.attachments.splice(index, 1);
      },

      // 模态框确定
      handleSubmit() {
        this.$http
          .post("basic", `taskMembers/saveTaskAttachments/${this.pkid}`, this.attachments)
          .then((res) => {
            console.log(res);
            if (res.success) {
              this.$message.success("保存成功！");
              this.$emit("save-success");
              this.dialogVisible = false;
            }
          })
          .catch(() => {
            this.$message.error("保存失败！");
            this.dialogVisible = false;
          });
      },
    },
  };
</script>

<style lang="scss">
.attachment-edit .el-dialog__header {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 99999;
  box-sizing: border-box;
}
.attachment-edit .el-dialog__footer {
  position: fixed;
  width: 100%;
  bottom: 0;
  z-index: 99999;
  box-sizing: border-box;
  background-color: #fff;
}

.attachment-edit .el-dialog {
  margin: 2% auto !important;
  transform: scale3d(1, 1, 1);
  padding-top: 30px;
  padding-bottom: 69px;
  height: 90%;
}

.attachment-edit .el-divider--horizontal {
  margin: 10px 0;
}

.attachment-edit .el-dialog .el-dialog__body {
  height: 100%;
  background-color: #fff;
  overflow: scroll;
}

// 加载效果水平垂直居中
.el-loading-spinner {
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
}
</style>
